import { render } from "./Liquidations25ApprovalHistory.vue?vue&type=template&id=a7a2291e"
import script from "./Liquidations25ApprovalHistory.vue?vue&type=script&lang=js"
export * from "./Liquidations25ApprovalHistory.vue?vue&type=script&lang=js"

import "./Liquidations25ApprovalHistory.vue?vue&type=style&index=0&id=a7a2291e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__